import { create } from 'zustand';

export const useUserStore = create((set) => ({
  user: null,
  updateUserDetail: (user) => set({ user:user }),
}));
